// Generated by Melange

import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

function initial(request_id) {
  return {
    request_id,
    budget: "1.00",
    project_version: 0,
    environment_version: 0,
    loading: true,
    pending: false,
    message: "",
    builds: /* [] */ 0
  };
}

function update(t, builds) {
  if (/* tag */ typeof builds !== "object" && typeof builds !== "function") {
    switch (builds) {
      case /* Loading */ 3 :
        return {
          request_id: t.request_id,
          budget: t.budget,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: true,
          pending: t.pending,
          message: "",
          builds: t.builds
        };
      case /* Pending */ 4 :
        return {
          request_id: t.request_id,
          budget: t.budget,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: t.loading,
          pending: true,
          message: "",
          builds: t.builds
        };
      default:
        return t;
    }
  } else {
    switch (builds.TAG) {
      case /* Edited */ 2 :
        return {
          request_id: builds._1,
          budget: builds._0,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: t.loading,
          pending: t.pending,
          message: "",
          builds: t.builds
        };
      case /* Environment */ 3 :
        return {
          request_id: t.request_id,
          budget: t.budget,
          project_version: builds._0,
          environment_version: builds._1,
          loading: false,
          pending: t.pending,
          message: t.message,
          builds: t.builds
        };
      case /* Builds */ 4 :
        return {
          request_id: t.request_id,
          budget: t.budget,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          builds: builds._0
        };
      case /* Accepted */ 5 :
        return {
          request_id: builds._0,
          budget: t.budget,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: t.loading,
          pending: false,
          message: t.message,
          builds: t.builds
        };
      case /* Failed */ 6 :
        return {
          request_id: t.request_id,
          budget: t.budget,
          project_version: t.project_version,
          environment_version: t.environment_version,
          loading: false,
          pending: false,
          message: builds._0,
          builds: t.builds
        };
      default:
        return t;
    }
  }
}

function money(text) {
  const value = Stdlib.float_of_string_opt(text);
  if (value === undefined) {
    return;
  }
  if (!(Stdlib__Float.is_finite(value) && value > 0 && value <= 2147)) {
    return;
  }
  const value$1 = Math.round(value * 1000000) | 0;
  if (value$1 > 0) {
    return value$1;
  }
  
}

function can_submit(t) {
  if (!t.loading && !t.pending && t.project_version > 0 && t.environment_version > 0) {
    return money(t.budget) !== undefined;
  } else {
    return false;
  }
}

function active(b) {
  return Stdlib__List.mem(b.status, {
    hd: "queued",
    tl: {
      hd: "building",
      tl: {
        hd: "cancelling",
        tl: /* [] */ 0
      }
    }
  });
}

function progress(b) {
  const match = b.status;
  switch (match) {
    case "cancelled" :
      return "Cancelled";
    case "cancelling" :
      return "Stopping build";
    case "failed" :
      return "Failed";
    case "queued" :
      return "Queued";
    case "ready" :
      return "Template ready";
    default:
      if (Stdlib__String.starts_with("snapshot_", b.phase)) {
        return "Publishing template";
      } else if (Stdlib__String.starts_with("project_", b.phase)) {
        return "Preparing repository";
      } else if (Stdlib__String.starts_with("environment_", b.phase) || Stdlib__String.starts_with("container_", b.phase)) {
        return "Building environment";
      } else if (Stdlib__List.mem(b.phase, {
          hd: "deleting",
          tl: {
            hd: "confirming",
            tl: {
              hd: "credential_cleanup",
              tl: /* [] */ 0
            }
          }
        })) {
        return "Cleaning up builder";
      } else {
        return "Preparing runtime";
      }
  }
}

function decode(json) {
  return {
    id: Mapre_wire__Json.string(json, "id"),
    status: Mapre_wire__Json.string(json, "status"),
    phase: Mapre_wire__Json.string(json, "phase"),
    revision: Mapre_wire__Json.string(json, "source_revision"),
    environment_version: Mapre_wire__Json.integer(json, "environment_version"),
    failure: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "failure_code"))
  };
}

export {
  initial,
  update,
  money,
  can_submit,
  active,
  progress,
  decode,
}
/* Mapre_wire__Json Not a pure module */
